// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgMaximizeIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M3 18.857V15.43a1 1 0 1 1 2 0v3.428c0 .08.064.143.143.143H8.57a1 1 0 1 1 0 2H5.143A2.143 2.143 0 0 1 3 18.857m16 0V15.43a1 1 0 1 1 2 0v3.428C21 20.041 20.04 21 18.857 21H15.43a1 1 0 1 1 0-2h3.428a.143.143 0 0 0 .143-.143M3 8.571V5.143C3 3.959 3.96 3 5.143 3H8.57a1 1 0 0 1 0 2H5.143A.143.143 0 0 0 5 5.143V8.57a1 1 0 0 1-2 0m16 0V5.143A.143.143 0 0 0 18.857 5H15.43a1 1 0 1 1 0-2h3.428C20.041 3 21 3.96 21 5.143V8.57a1 1 0 1 1-2 0" />
  </g>
);
export default SvgMaximizeIcon;
SvgMaximizeIcon.displayName = 'SvgMaximizeIcon';
